import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  // Converte l'oggetto NgbDateStruct in una stringa (per la visualizzazione)
  format(date: NgbDateStruct | null): string {
    if (!date) {
      return '';
    }
    const day = date.day.toString().padStart(2, '0');
    const month = date.month.toString().padStart(2, '0');
    return `${day}/${month}/${date.year}`;
  }

  // Converte una stringa nel formato DD/MM/YYYY in un oggetto NgbDateStruct
  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }
    const parts = value.split('/');
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      return { day, month, year };
    }
    return null;
  }
}
